import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './slow-connection-snack-bar.component.html',
  styleUrls: ['./slow-connection-snack-bar.component.scss'],
  imports: [MatSnackBarModule, MatIconModule],
  standalone: true,
})
export class SlowConnectionSnackBarComponent implements OnInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  ngOnInit(): void {}
}
